import { NcwOnboardingSlideFour } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type SlideProps } from '@capsicum/features/nc-onboarding/shared';

import { useOnboardingSlidesTranslations } from '../../../hooks/onboarding/useOnboardingSlidesTranslations';
import { Shell } from '../../shell';
import { Description, Title } from '../Page.styled';

export const FourthSlide = ({ onNextSlide }: SlideProps) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell
			cta={
				<Button
					testID="ncOnboarding-create-button"
					text={$t('ncOnboard.actions.create')}
					onClick={onNextSlide}
				/>
			}
			image={NcwOnboardingSlideFour}
		>
			<Title color="onDark.enabled" variant="display2">
				{$t('ncOnboard.fourthSlide.title')}
			</Title>

			<Description color="onDark.enabled" variant="text2">
				{$t('ncOnboard.fourthSlide.description')}
			</Description>
		</Shell>
	);
};
